/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import progressBarConfig from "../config/progressBar.config.json";
import selectCostumeConfig from "../config/selectCostume.config.json";
import previewConfig from "../config/preview.config.json";
import paymentConfig from "../config/payment.config.json";
import paymentFACConfig from "../config/paymentNewForm.config.json";
import loadingConfig from "../config/loading.config.json";
import paymentFromCart from "../config/paymentFormCart.config.json";
import errorConfig from "../config/error.config.json";
import paymentFrom from "../config/paymentForm.config.json";
import paymentSummaryConfig from "../config/paymentSummary.config.json";
import {
  tribeTermsAndConditions,
  pureTermsAndConditions,
  calTermsAndConditions,
  secretsTermsAndConditions,
  hartsTermsAndConditions,
  theLostTribeTermsAndConditions,
  rogueTermsAndConditions,
  blissTermsAndConditions,
} from "../config/termsAndConditions";

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    return {
      progressBar: progressBarConfig,
      selectCostume: selectCostumeConfig,
      preview: previewConfig,
      payment: {
        ...paymentConfig,
        tribeTermsAndConditions,
        pureTermsAndConditions,
        calTermsAndConditions,
        secretsTermsAndConditions,
        hartsTermsAndConditions,
        calTermsAndConditions,
        theLostTribeTermsAndConditions,
        rogueTermsAndConditions,
        blissTermsAndConditions,
      },
      payMethodForm: paymentFrom,
      payMethodNewForm: paymentFACConfig,
      payMethodFormCart: paymentFromCart,
      paymentSummaryConfig: paymentSummaryConfig,
      loading: loadingConfig,
      error: errorConfig,
    };
  }
}
